// extracted by mini-css-extract-plugin
export default {"container":"style_container__z1Bas","content":"style_content__Fe6Fc"};